import { Group, Stack, Switch, Text } from "@mantine/core";
import { IIssueBoardApi } from "@mcapps/shared";
import React from "react";
import { FailedAlert } from "../../../../../components";
import { usePostProjectByProjectIdIssueboardRisikoIsactiveMutation } from "../../../../../../openapi";
import SettingsCardWrapper from "../SettingsCardWrapper";
import EvaluationCategories from "./EvaluationCategories/EvaluationCategories";
import RisikoProbabilitySettings from "./RisikoProbabilitySettings";

const IssueRisiko: React.FC<{ issueBoard: IIssueBoardApi }> = ({ issueBoard }) => {
  const [setRisikoActive, { error: activateRisikoError }] = usePostProjectByProjectIdIssueboardRisikoIsactiveMutation();

  return (
    <SettingsCardWrapper title={"Risiko"}>
      {activateRisikoError != null && <FailedAlert />}
      <Group align="center" gap="xs" wrap="nowrap">
        <Text size="1em">
          <i className="fa fa-info-circle fa-fw text-info" /> Aktiver risiko
        </Text>
        <Switch
          size="sm"
          onChange={(event) =>
            setRisikoActive({
              projectId: issueBoard.project,
              body: {
                issueBoardId: issueBoard._id,
                isActive: event.currentTarget.checked,
              },
            })
          }
          checked={issueBoard.risikoSection?.isActive === true}
        />
      </Group>

      {issueBoard.risikoSection?.isActive === true && (
        <Stack>
          <RisikoProbabilitySettings issueBoard={issueBoard} />
          <EvaluationCategories issueBoard={issueBoard} />
        </Stack>
      )}
    </SettingsCardWrapper>
  );
};

export default IssueRisiko;
